import React from 'react';
import { actions } from '@ecosystem/newron-design-system';

export interface CommonActionsMenuProps {
  children: React.ReactNode[];
  isDisabled?: boolean;
}

const { Menu } = actions;

const registeredPlatformItems: { item: React.FC; position: number }[] = [];

export const registerCommonActionsMenuItem = (item: React.FC, position: number) => {
  if (!registeredPlatformItems.some(i => i.item === item || i.position === position)) {
    registeredPlatformItems.push({ item, position });
  }
};

export const CommonActionsMenu: React.FC<CommonActionsMenuProps> = ({ children, isDisabled }) => {
  const [platformItems, setPlatformItems] = React.useState<React.ReactNode[]>([]);
  const [propositionsItems, setPropositionsItems] = React.useState<React.ReactNode[]>([]);

  React.useEffect(() => {
    const platformItems: [React.ReactElement, number][] = [];

    const propositionsItems: React.ReactNode[] = [];

    children.forEach(child => {
      if (React.isValidElement(child)) {
        const matchingRegisteredItem = registeredPlatformItems.find(i => i.item === child.type);
        if (matchingRegisteredItem) {
          platformItems.push([child, matchingRegisteredItem.position]);
        } else {
          propositionsItems.push(child);
        }
      }
    });

    // sorting in-place
    platformItems.sort((a, b) => a[1] - b[1]);

    setPlatformItems(platformItems.map(item => item[0]));
    setPropositionsItems(propositionsItems);
  }, [children]);

  if (platformItems.length === 0 && propositionsItems.length === 0) {
    return null;
  }

  return (
    <Menu position="bl" testId="common-actions-menu" isDisabled={isDisabled}>
      <Menu.MoreButton title="More" />
      <Menu.List testId="common-actions-menu-list" renderWhenCollapsed={true}>
        {platformItems}
        {propositionsItems}
      </Menu.List>
    </Menu>
  );
};
